export const LinkComponent = ({ href, children, style, props }) => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      {...props}
      style={style}
    >
      {children}
    </a>
  )
}
